import { z } from "zod";

export const FactNodeContentSchema = z.object({});

export const FactNodeSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string().uuid(),
  content: FactNodeContentSchema,
});

export const FactEdgeMetadataSchema = z.object({});

export const FactEdgeSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string().uuid(),
  metadata: FactEdgeMetadataSchema,
});

export type FactNode = z.infer<typeof FactNodeSchema>;
export type FactNodeContent = z.infer<typeof FactNodeContentSchema>;
export type FactEdge = z.infer<typeof FactEdgeSchema>;
export type FactEdgeMetadata = z.infer<typeof FactEdgeMetadataSchema>;
